import React, {useState, useEffect} from 'react';
import axios from '../Common/axios';
import {Button, Select, Layout, Input, Modal} from "antd";
import {CodeSelect} from '../Common/CodeSelect';
import {postSaveAnalysisCreate, getFindAnalysisList} from '../Common/api';
import {getNowDate} from '../Common/util';

const {Option} = Select;


/** -------------------------------------------------------------------------- **/
function TemplateCreate({ p_companyCode, p_assetType, p_assetTypeName, onClose }) {

    // 변수 선언
    const [companyCode, setCompanyCode] = useState(p_companyCode);
    const [assetType, setAssetType] = useState(p_assetType);
    const [assetTypeName, setAssetTypeName] = useState(p_assetTypeName);
    const [reportName, setReportName] = useState('');
    const [reportDesc, setReportDesc] = useState('');
    const [reportOrg, setReportOrg] = useState('');
    const [reportOrgOption, setReportOrgOption] = useState([]);
    const [uploading, setUploading] = useState(false);
    const titleName="템플릿 등록";

    const onClickCloseHandler = () => {
        //window.close();
        onClose?.(false);
    }

    const onClickSaveHandler = () => {
        
        // 필수조건 체크
        if (companyCode == '' || assetType == '' || reportName == '' ) {
            Modal.info({title: "회사코드나 자산타입, 리포트명이 필요합니다."});
            return;
        }

        setUploading(true);
            axios.post(postSaveAnalysisCreate(), {
                companyCode : companyCode,
                assetType : assetType,
                reportName : reportName,
                reportDesc : reportDesc,
                reportOrg : reportOrg
            },{logType:'/create/Template/', logParam : reportName})
            .then((response) => {
                //console.log(response);
                setUploading(false);
                //Modal.info({title: "OK.", okText:"Close"});
                if(response.data.status == 'success') {
                    Modal.info({title:titleName, content:response.data.report_id+" 템플릿이 생성되었습니다.", okText:"Close", onOk() {
                        //정상적으로 생성된 경우, 부모창을 재조회하고 팝업창을 닫는다.
                        onClose?.(true);
                        //window.close();
                    }});
                } else {
                    Modal.info({title:titleName, content:response.data, okText:"Close"});  
                }
            })
            .catch((error) => {
                setUploading(false);
                Modal.error({title:titleName, content:error.message, okText:"Close"});
            });
    };

    // 회사코드 변경
    const onChangeCompanyCode = (value) => {
        setCompanyCode(value);
    };

    // 자산유형 변경
    const onChangeAssetType = (value, option) => {
        setAssetType(value);
        setAssetTypeName(option.children[2]);
    };

    // 생성기준 변경
    const onChangeReportOrg = (value) => {
        setReportOrg(value);
    };
    
    // InputText 입력값 변경
    const onChangeInputHandler = (event) => {
        if (event.target.id == "reportName") {
            setReportName(event.target.value);
        } else if (event.target.id == "reportDesc") {
            setReportDesc(event.target.value);
        } 
    };

    // 템플릿 제목
    useEffect(() => {
        setReportName('[' + getNowDate('-') + '] ' + '템플릿' + ' (' + assetTypeName + ')');
    }, [companyCode, assetType]);
    
    // 복사대상 레포트 조회
    useEffect(() => {
        findReportOrg();
    }, [assetType]);

    const findReportOrg = () => {
        //자동조회
        if(assetType != '') {
            //getFindAnalysisList(companyCode, assetType, reportName, startYmd, endYmd)
            axios.get(getFindAnalysisList('TMPL', assetType, '', '', ''))
                .then((response) => {
                    //console.log(response);
                    setReportOrgOption(response.data);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }

    return (
    <div className='layer_overlay'>
        <div className='layer_wrap'>
            <div className='popup_header'>
                <div className='popup_title'>
                    템플릿 등록
                </div>
            </div>
            <div className="section">
                <table className='search'>
                    <colgroup>
                        <col style={{width:'20%'}} />
                        <col />
                    </colgroup>
                    <tbody>
                    <tr>
                        <th><span className='req'>*</span>구분</th>
                        <td>
                            <Select id="companyCode"
                                    size="small"
                                    style={{width: "80%"}}
                                    value={companyCode}
                                    onChange={onChangeCompanyCode}
                                    disabled={true}
                            >
                                <Option key={0} value={'TMPL'}>{'템플릿'}</Option>
                            </Select>
                        </td>
                    </tr>
                    <tr>
                        <th><span className='req'>*</span>자산구분</th>
                        <td>
                            <CodeSelect codeType="asset_type" 
                                        id="assetType"
                                        value={assetType}
                                        disabled={false}
                                        onChangeHandler={onChangeAssetType}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th><span className='req'>*</span>템플릿 제목</th>
                        <td>
                            <Input id="reportName" size="small" style={{width: "80%"}}
                                    allowClear
                                    value={reportName}
                                    onChange={onChangeInputHandler}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>템플릿 설명</th>
                        <td>
                            <Input id="reportDesc" size="small" style={{width: "80%"}}
                                    allowClear
                                    value={reportDesc}
                                    onChange={onChangeInputHandler}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>복사대상 분석기준</th>
                        <td>
                        <Select id="reportOrg"
                                    size="small"
                                    style={{width: "80%"}}
                                    value={reportOrg}
                                    onChange={onChangeReportOrg}
                            >
                                {reportOrgOption.length > 0 &&
                                    reportOrgOption.map((item, i) => {
                                        return (
                                            <Option key={i} value={item.report_id}>{item.report_nm}({item.report_id})</Option>
                                        )
                                    })}
                            </Select>
                            <div>- 복사대상 템플릿의 분석기준(진단항목,대응방안,위협)이 자동으로 복사됩니다.</div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div className="popup_button_close">
                    <Button
                        type="primary"
                        onClick={onClickSaveHandler}
                        loading={uploading}
                        style={{marginRight: '10px'}}
                    >
                        {'저장'}
                    </Button>
                    <Button
                        type="default"
                        onClick={onClickCloseHandler}
                        style={{marginLeft: '10px'}}
                    >
                        {'닫기'}
                    </Button>
            </div>
            </div>
            </div>
    );
}
export default TemplateCreate;